import { listDimensionLabels } from "features/analytics/services/analyticsLabelService";
import { useGlobalSharedState } from "Hooks/useSharedState";
import { useMemo } from "react";

const fetchDimensionLabels = async () => {
  let res = await listDimensionLabels();
  return res;
};

export const useDimensionLabels = () => {
  const { state, setState, loading } = useGlobalSharedState(
    "dimensionLabels",
    [],
    fetchDimensionLabels
  );

  const visibleDimensionLabels = useMemo(() => {
    return state.filter((l) => !l.hidden);
  }, [state]);

  return {
    dimensionLabels: visibleDimensionLabels,
    allDimensionLabels: state,
    setDimensionLables: setState,
    loading,
  };
};
